import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient";
import { PaginationResponse, ResponseData } from "../types/_public";
import { ICategorySport, IGame, ISport, ISportCategory, ISportStatistics } from "../types/newshub/_sport";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";
const api = new APIClient();

const path_sports = PATH_NEWSHUB_API + '/sports';

const userApi = {
  sports(params: any): Promise<AxiosResponse<ResponseData<ISportStatistics[]> & PaginationResponse, any>> {
    const url = `${path_sports}/football`
    return api.get(url, params)
  },
  games(params: any): Promise<AxiosResponse<ResponseData<IGame[]> & PaginationResponse, any>> {
    const url = `${path_sports}/games`
    return api.get(url, params)
  },
  allSports(params: any = {}): Promise<AxiosResponse<ResponseData<ISport[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/sports`
    return api.get(url, params)
  },
  categories(params: any = {}): Promise<AxiosResponse<ResponseData<ISportCategory[]> & PaginationResponse, any>> {
    const url = `${PATH_NEWSHUB_API}/categories`
    return api.get(url, { ...params, type: 'sport', })
  },
  searchCategories(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICategorySport[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/categories`;
    return api.get(url, params);
  },
  putStatusActiveSportTeam(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<ISport[]>, any>> {
    const url = `${path_sports}/football/${id}/status`;
    return api.post(url, dataForm)
  },
}
export default userApi
